import Axios from '../../models/Axios';
import { LOCAL_URL } from '../../helper/constant';
import * as Types from '../../constants/actionTypes';

const END_POINT = {
    MODULE: '/portalModules',
    MODULE_REMOVE: '/portalModules/remove',
    MODULE_GET: '/portalModules/getModules',
    REQ_TYPE: '/portalrequesttype/listPortalRequestType',
    P_COUNTRY: '/programCountries/listProgramCountries',
    SITE: '/client/listPortalCollections',
    PROGRAM_DOCUMENT_TYPE_URL: '/portaldocumenttypes',
    
    GET_GROUP: '/portalgroups/getGroups',
}
export const GET_REPORT_MODULE = (where) => async (dispatch) => {
    try {
        const { portalId, clientId, groupId } = where
        if (!portalId || !clientId) {
            dispatch({ type: Types.REPORT_MODULE_ERR, err: `Please Provide portalId and clientId` });
            return
        }
        const res = await Axios.axios.get(`${LOCAL_URL}${END_POINT.MODULE_GET}?portalId=${portalId}&clientId=${clientId}&groupId=${groupId}`);
        dispatch({ type: Types.REPORT_MODULE_DATA, data: res.data });
    } catch (exception) {
        return dispatch({ type: Types.REPORT_MODULE_ERR, err: exception.message });
    }
}

export const ADD_REPORT_MODULE = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload
        if (!portalId || !clientId) {
            dispatch({ type: Types.REPORT_MODULE_ERR, err: `Please Provide portalId and clientId` });
            return
        }
        const res = await Axios.axios.post(`${LOCAL_URL}${END_POINT.MODULE}`, payload);
        payload.id = res.data.id;
        dispatch({ type: Types.REPORT_MODULE_ADD, data: payload });
    } catch (exception) {
        return dispatch({ type: Types.REPORT_MODULE_ERR, err: exception.message });
    }
}

export const UPDATE_REPORT_MODULE = (payload) => async (dispatch) => {
    try {
        if (!payload.id || payload.id < 0) {
            dispatch({ type: Types.REPORT_MODULE_ERR, err: `Please Provide Module Id` });
            return
        }
        await Axios.axios.post(`${LOCAL_URL}${END_POINT.MODULE}`, payload);
    } catch (exception) {
        return dispatch({ type: Types.REPORT_MODULE_ERR, err: exception.message });
    }
}

export const REMOVE_MODULE = (id) => async (dispatch) => {
    try {
        if (!id || id < 0) {
            dispatch({ type: Types.REPORT_MODULE_ERR, err: `Please Provide Module Id` });
            return
        }
        await Axios.axios.delete(`${LOCAL_URL}${END_POINT.MODULE_REMOVE}/${id}`);
    } catch (exception) {
        return dispatch({ type: Types.REPORT_MODULE_ERR, err: exception.message });
    }
}

export const GET_GROUP = (payload) => async (dispatch) => {

    try {
        const { portalId, clientId } = payload
        if (!portalId || !clientId) {
            dispatch({ type: Types.GROUP_ERR, err: `Please Provide portalId and clientId` });
            return
        }
        // const filter = encodeURIComponent(JSON.stringify({ payload }));
        const res = await Axios.axios.get(`${LOCAL_URL}${END_POINT.GET_GROUP}`, { params: payload });
        dispatch({ type: Types.GROUP_DATA, data: res.data });
        return res.data && res.data.data
    } catch (error) {
        dispatch({ type: Types.GROUP_ERR, err: error.message });
        return error
    }
}

export const SET_GROUP_ID = (groupId) => async (dispatch) => {
    try {
        dispatch({ type: Types.GROUP_ID, data: groupId });
    } catch (exception) {
        return dispatch({ type: Types.GROUP_ERR, err: exception.message });
    }
}

export const GET_ALL_PROGRAM_DOCUMENT_DETAILS = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Please provide Portal Information` })
            return;
        }
        const PROGRAM_DOCUMENT_URL = `${LOCAL_URL}${END_POINT.PROGRAM_DOCUMENT_TYPE_URL}/getPortalDocumentList`
        const response = await Axios.axios.get(PROGRAM_DOCUMENT_URL, { params: payload })
        return response.data.data
    } catch (error) {
        let message = error.message
        if (!message && error.error) {
            message = error.error.message
        }
        dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: message })
    }
}

export const PORTAL_GROUP_LIST = async (payload) => {
    try {
        const res = await Axios.axios.get(`${LOCAL_URL}/portalgroups/getGroupList`, { params: payload });
        return res.data
    } catch (error) {
        return error
    }
}

export const PORTAL_DEFAULT_REISTRATION_GROUP = async (payload) => {
    try {
        const res = await Axios.axios.get(`${LOCAL_URL}/portalgroups/getDefaultGroupForRegistrationForm`, { params: payload });
        return res.data
    } catch (error) {
        return error
    }
}
export const PORTAL_GROUP_BY_ID = async (payload) => {
    try {
        const res = await Axios.axios.get(`${LOCAL_URL}/portalgroups/getGroupById`, { params: payload });
        return res.data
    } catch (error) {
        return error
    }
}
export const PORTAL_GROUP_SAVE = async (payload) => {
    try {
        const response = await Axios.axios.post(`${LOCAL_URL}/portalgroups/saveGroup`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const PORTAL_GROUP_REMOVE = async (payload) => {
    try {
        const response = await Axios.axios.post(`${LOCAL_URL}/portalgroups/removeGroups`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}